/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const LoadDocumentType = {
    Bol: 'BOL',
    Pod: 'POD',
    PhotoLoaded: 'PHOTO_LOADED',
    PhotoUnloaded: 'PHOTO_UNLOADED'
} as const;
export type LoadDocumentType = typeof LoadDocumentType[keyof typeof LoadDocumentType];

